import { useCandidateProfile } from 'candidate_profile_redesign/store';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('candidate_profile_redesign.permissions.email');
export const useEmailPermissions = () => {
  const {
    state: {
      doNotEmail,
      hasAgencyEmail,
      header: { emails },
      currentUser: { permissions },
    },
  } = useCandidateProfile();

  const userCanEmail = permissions.canEmail;
  const hasEmail = emails?.length > 0 || hasAgencyEmail;
  const canEmail = userCanEmail && !doNotEmail && hasEmail;

  let helperText = '';
  if (!userCanEmail) {
    helperText = t('no_permissions');
  } else if (!hasEmail) {
    helperText = t('no_email');
  } else {
    helperText = t('do_not_email');
  }

  return {
    canEmail,
    helperText,
  };
};
